<template>
  <el-col :span="12">
    <el-card>
      <div slot="header">
        <span>申请-专业分布</span>
      </div>
      <div id="myChartSpe" :style="{ height: '330px' }"></div>
    </el-card>
  </el-col>
</template>

<script>
import * as echarts from 'echarts';
import { chartSpe } from '@/api/home/admin.js';

export default {
  data() {
    return {
      xAxisData: [],
      seriesData: []
    };
  },
  methods: {
    drawChart() {
      // 基于准备好的dom，初始化echarts实例
      var myChartSpe = echarts.init(document.getElementById('myChartSpe'));
      // 绘制图表
      myChartSpe.setOption({
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData,
          boundaryGap: false,
          axisLabel: {
            rotate: 60,
            fontSize: '10'
          }
        },
        grid: {
          top: '3%',
          left: '50',
          right: '4%'
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            type: 'bar',
            data: this.seriesData,
            barWidth: '10',
            itemStyle: {
              normal: {
                barBorderRadius: [30, 30, 0, 0]
              }
            }
          }
        ]
      });
    },
    getData() {
      chartSpe().then(res => {
        res.xAxisData.forEach(val => {
          this.xAxisData.push(val);
        });
        res.seriesData.forEach(val => {
          this.seriesData.push(val);
        });
        this.drawChart();
      });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style></style>
